angular.module('homebot.directives')

  .directive('notifications', ['NotificationService', 'SessionService', '$timeout', '$rootScope', function(NotificationService, SessionService, $timeout, $rootScope){
    return {
      restrict: 'EA',
      controllerAs: 'notificationsCtrl',
      bindToController: {
        homeId: '@',
        notificationCount: '@',
        notificationsArray: '=',
        user: '=',
      },
      scope: {},
      templateUrl: '/homes/templates/partials/notifications.html',

      controller: function(){
        let ctrl = this;
        let isHomeowner = !SessionService.isAgent();

        $rootScope.$on('NavDropdownChange', (event, data) => {
          if(data.currentDropdown === 'notifications' && ctrl.notificationsArray && ctrl.notificationCount && isHomeowner){
            NotificationService.markNotificationsAsSeen(ctrl.user, ctrl.homeId);
            ctrl.notificationCount = 0;
          }
        });

        ctrl.setNotificationsSeen = function() {
          $timeout(function(){
            if (isHomeowner) {
              _.each(ctrl.notificationsArray, function(notification) {
                notification.is_seen = true;
              });
            }
          });
        };
      },

      link: function($scope, el, attrs, ctrl){

      }
    }

  }]);
